// extracted by mini-css-extract-plugin
export default {"base":"HrrMap_base__i6Bi9"};